/* eslint-disable */
// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zMicrosoftAspNetCoreMvcProblemDetails = z.strictObject({
  type: z.string().nullish(),
  title: z.string().nullish(),
  status: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    .nullish(),
  detail: z.string().nullish(),
  instance: z.string().nullish(),
});

export const zMicrosoftAspNetCoreHttpHttpValidationProblemDetails = z.strictObject({
  type: z.string().nullish(),
  title: z.string().nullish(),
  status: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    .nullish(),
  detail: z.string().nullish(),
  instance: z.string().nullish(),
  errors: z.record(z.string(), z.array(z.string())).nullish(),
});

/**
 * ISO 3166-1 alpha-2 country metadata item.
 */
export const zCslCmpDeviceLocationsApiFeaturesMetaDataGetIsoCountryCodesGetIsoCountryCodeItemV1 =
  z.strictObject({
    countryCode: z.string().nullish(),
    countryName: z.string().nullish(),
  });

/**
 * GetProductActivityByCountryResponse for the GetIsoCountryCodes endpoint.
 * Contains a complete, deduplicated list of ISO 3166-1 alpha-2 country codes
 * ordered alphabetically by English name.
 */
export const zCslCmpDeviceLocationsApiFeaturesMetaDataGetIsoCountryCodesGetIsoCountryCodesResponseV1 =
  z.strictObject({
    items: z
      .array(zCslCmpDeviceLocationsApiFeaturesMetaDataGetIsoCountryCodesGetIsoCountryCodeItemV1)
      .nullish(),
  });

/**
 * row carrying one (Country, ProductType, Count) data point.
 */
export const zCslCmpDeviceLocationsApiFeaturesGetProductTypeByCountryGetProductTypeByCountryRecordV1 =
  z.strictObject({
    country: z.string().nullish(),
    productType: z.string().nullish(),
    count: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .optional(),
  });

/**
 * Represents the record containing the last session summary for products associated with a specific account.
 */
export const zCslCmpDeviceLocationsApiFeaturesGetProductLastSessionSummaryGetProductLastSessionSummaryRecordV1 =
  z.strictObject({
    active90Days: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .nullish(),
    active30Days: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .nullish(),
    active24Hours: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .optional(),
    countryCount: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .optional(),
    activeBeyond90Days: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .nullish(),
  });

/**
 * Per-country active-device counts returned by the GetProductActivityByCountry endpoint.
 */
export const zCslCmpDeviceLocationsApiFeaturesGetProductActivityByCountryGetProductActivityByCountryRecordV1 =
  z.strictObject({
    country: z.string().nullish(),
    active90Days: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .optional(),
    active30Days: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .optional(),
    active24Hours: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .optional(),
    activeBeyond90Days: z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
      .optional(),
  });

/**
 * Represents a GeoJSON Polygon geometry used for debug tile bounding boxes.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPolygonV1 = z.strictObject({
  type: z.string().readonly().nullish(),
  coordinates: z.array(z.array(z.array(z.number()))).nullish(),
});

/**
 * Represents a GeoJSON Point geometry used for individual device locations or cluster centroids.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPointV1 = z.strictObject({
  type: z.string().readonly().nullish(),
  coordinates: z.array(z.number()).nullish(),
});

/**
 * Represents a GeoJSON Feature, which consists of a geometry
 * (e.g., point, polygon) and associated properties (metadata). In this context,
 * it is used to represent individual device locations or geohash-based clusters.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonFeatureV1 = z.strictObject({
  type: z.string().readonly().nullish(),
  geometry: z
    .union([
      zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPointV1,
      zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPolygonV1,
    ])
    .nullish(),
  properties: z.record(z.string(), z.unknown()).nullish(),
});

/**
 * Represents a GeoJSON FeatureCollection, which is a collection of spatial
 * features (points, polygons, etc.) along with their associated properties.
 * This is the top-level structure returned to map clients for rendering device locations.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonFeatureCollectionV1 = z.strictObject({
  type: z.string().readonly().nullish(),
  features: z.array(zCslCmpDeviceLocationsApiContractsGeoJsonFeatureV1).nullish(),
});

/**
 * Represents a GeoJSON Polygon geometry used for debug tile bounding boxes.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPolygonV1Writable = z.strictObject({
  coordinates: z.array(z.array(z.array(z.number()))).nullish(),
});

/**
 * Represents a GeoJSON Point geometry used for individual device locations or cluster centroids.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPointV1Writable = z.strictObject({
  coordinates: z.array(z.number()).nullish(),
});

/**
 * Represents a GeoJSON Feature, which consists of a geometry
 * (e.g., point, polygon) and associated properties (metadata). In this context,
 * it is used to represent individual device locations or geohash-based clusters.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonFeatureV1Writable = z.strictObject({
  geometry: z
    .union([
      zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPointV1Writable,
      zCslCmpDeviceLocationsApiContractsGeoJsonGeometryPolygonV1Writable,
    ])
    .nullish(),
  properties: z.record(z.string(), z.unknown()).nullish(),
});

/**
 * Represents a GeoJSON FeatureCollection, which is a collection of spatial
 * features (points, polygons, etc.) along with their associated properties.
 * This is the top-level structure returned to map clients for rendering device locations.
 */
export const zCslCmpDeviceLocationsApiContractsGeoJsonFeatureCollectionV1Writable = z.strictObject({
  features: z.array(zCslCmpDeviceLocationsApiContractsGeoJsonFeatureV1Writable).nullish(),
});

export const zGetProductActivityByCountryQuery = z.strictObject({
  accountReferenceId: z.string(),
  productTypes: z.array(z.string()).optional(),
  countries: z.array(z.string()).optional(),
  activityDays: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    .optional(),
});

/**
 * Success
 */
export const zGetProductActivityByCountryResponse = z.array(
  zCslCmpDeviceLocationsApiFeaturesGetProductActivityByCountryGetProductActivityByCountryRecordV1,
);

export const zGetProductLastSessionSummaryQuery = z.strictObject({
  accountReferenceId: z.string(),
  productTypes: z.array(z.string()).optional(),
  countries: z.array(z.string()).optional(),
  activityDays: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    .optional(),
});

/**
 * Success
 */
export const zGetProductLastSessionSummaryResponse =
  zCslCmpDeviceLocationsApiFeaturesGetProductLastSessionSummaryGetProductLastSessionSummaryRecordV1;

export const zGetProductTypeByCountryQuery = z.strictObject({
  accountReferenceId: z.string(),
  productTypes: z.array(z.string()).optional(),
  countries: z.array(z.string()).optional(),
  activityDays: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    .optional(),
});

/**
 * Success
 */
export const zGetProductTypeByCountryResponse = z.array(
  zCslCmpDeviceLocationsApiFeaturesGetProductTypeByCountryGetProductTypeByCountryRecordV1,
);

export const zGetProductLocationsQuery = z.strictObject({
  AccountReferenceId: z.string(),
  DeviceId: z.string().optional(),
  ProductTypes: z.array(z.string()).optional(),
  Countries: z.array(z.string()).optional(),
  ActivityDays: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    .optional(),
  ZoomLevel: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
  TileLocationX: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
  TileLocationY: z
    .int()
    .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
    .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
});

/**
 * Success
 */
export const zGetProductLocationsResponse =
  zCslCmpDeviceLocationsApiContractsGeoJsonFeatureCollectionV1;

export const zGetSingleLocationQuery = z.strictObject({
  DeviceId: z.string(),
});

/**
 * Success
 */
export const zGetSingleLocationResponse =
  zCslCmpDeviceLocationsApiContractsGeoJsonFeatureCollectionV1;

/**
 * Success
 */
export const zGetIsoCountryCodesResponse =
  zCslCmpDeviceLocationsApiFeaturesMetaDataGetIsoCountryCodesGetIsoCountryCodesResponseV1;
